module.exports = __webpack_public_path__ + "img/tab5.2546cfd4.png";